import '../styles.less';
import { ILSButton } from '@common/components';
import { useLink } from '@common/hooks/history/use-link';
import { ModulePath } from '@common/types';

export const ILSPlannerNew = () => {
  const { handleClick } = useLink(ModulePath.Planner + ModulePath.Data);
  return <ILSButton type={'primary'} className={'planner-new-button'} children={'Начать планирование'} onClick={handleClick} />;
};
